module.exports = "data:image/gif;base64,R0lGODlhDwAPAKIAAFtbW1VVVWhoaGJiYv///wAAAAAAAAAAACH5BAAAAAAALAAAAAAPAA8AAAMwOLHcPGCISauAwOoJ4vhg+HVkR5QoSpxpurIt+cLxG5frjd9Ov3S+HjDYAAR0pEACADs="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/shared/right-btn.gif
 ** module id = 525
 ** module chunks = 0
 **/